define("shared/components/shared/ui/error-banner", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cPM--badgeWrapper">
    <div class="cPM--badge cPM--badge--danger">
      <span>
        {{@text}}
      </span>
    </div>
  </div>
  */
  {
    "id": "FZg1Yvkw",
    "block": "[[[10,0],[14,0,\"cPM--badgeWrapper\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cPM--badge cPM--badge--danger\"],[12],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[1,[30,1]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@text\"],false,[]]",
    "moduleName": "shared/components/shared/ui/error-banner.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});